import { render } from "./CommentIndex.vue?vue&type=template&id=b7163fd0"
import script from "./CommentIndex.vue?vue&type=script&lang=js"
export * from "./CommentIndex.vue?vue&type=script&lang=js"

import "./CommentIndex.vue?vue&type=style&index=0&id=b7163fd0&lang=css"

import exportComponent from "/Users/ratul/Code/vue/jourly-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__